"use client";
import * as React from "react";
const SvgTrashSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M.86 16h10.28V3.56H.86zM12 .89H9L8.14 0H3.86L3 .89H0v1.78h12z" }));
export {
  SvgTrashSharp as default
};
